import { render, staticRenderFns } from "./BankTransactions.vue?vue&type=template&id=0ed06274&scoped=true&"
import script from "./BankTransactions.vue?vue&type=script&lang=js&"
export * from "./BankTransactions.vue?vue&type=script&lang=js&"
import style0 from "./BankTransactions.vue?vue&type=style&index=0&id=0ed06274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed06274",
  null
  
)

export default component.exports